import img1 from "../Images/1.webp";
import img2 from "../Images/2.webp";
import img3 from "../Images/3.webp";
import img4 from "../Images/4.webp";
import img5 from "../Images/5.webp";
import img6 from "../Images/6.webp";
import img7 from "../Images/7.webp";
import img8 from "../Images/8.webp";
import img9 from "../Images/9.webp";
import img10 from "../Images/10.webp";
import img11 from "../Images/11.webp";
import img12 from "../Images/12.webp";
import img13 from "../Images/13.webp";
import img14 from "../Images/14.webp";

const perfumesData = [
  {
    name: "Regal Cognac Infusion",
    img: img1,
    gender: "Male",
    season: "Summer",
    occasion: "Evening",
    notes: ["Cognac", "Leather", "Amber"],
    intensity: "strong",
    description:
      "An opulent blend of cognac and leather with an amber finish, perfect for sultry summer evenings.",
    price: "450.0",
  },
  {
    name: "Botanical Bloom Elixir",
    img: img2,
    gender: "Female",
    season: "Spring",
    occasion: "Brunch",
    notes: ["Peony", "Lily", "Green Tea"],
    intensity: "light",
    description:
      "A fresh, floral fragrance that radiates elegance — ideal for springtime brunches.",
    price: "300.0",
  },
  {
    name: "Aqua Radiance Perfume",
    img: img3,
    gender: "Unisex",
    season: "Summer",
    occasion: "Casual",
    notes: ["Citrus", "Marine", "Mint"],
    intensity: "moderate",
    description:
      "A crisp and energizing scent inspired by ocean breezes and summer citrus.",
    price: 350.0,
  },
  {
    name: "Alchemist's Rose Potion",
    img: img4,
    gender: "Female",
    season: "Fall",
    occasion: "Romantic",
    notes: ["Rose", "Amber", "Musk"],
    intensity: "strong",
    description:
      "A mysterious and sensual blend of deep rose and musk, designed for autumn romance.",
    price: 400.0,
  },
  {
    name: "Dark Timber Essence",
    img: img5,
    gender: "Male",
    season: "Winter",
    occasion: "Formal",
    notes: ["Cedar", "Sandalwood", "Patchouli"],
    intensity: "strong",
    description:
      "A sophisticated, woody composition suited for formal gatherings in the cold months.",
    price: 500.0,
  },
  {
    name: "Azure Floral Aura",
    img: img6,
    gender: "Female",
    season: "Spring",
    occasion: "Daytime",
    notes: ["Jasmine", "Bluebell", "Water Lily"],
    intensity: "moderate",
    description:
      "Bright and graceful, with dewy floral notes that bloom beautifully in the daylight.",
    price: 350.0,
  },
  {
    name: "Lavender Dew Spritz",
    img: img7,
    gender: "Unisex",
    season: "Summer",
    occasion: "Relaxation",
    notes: ["Lavender", "Citrus", "Herbs"],
    intensity: "light",
    description:
      "A calming herbal scent with hints of citrus, made for summer relaxation.",
    price: 300.0,
  },
  {
    name: "Crimson Petal Drop",
    img: img8,
    gender: "Female",
    season: "Fall",
    occasion: "Date Night",
    notes: ["Rose", "Raspberry", "Vanilla"],
    intensity: "strong",
    description:
      "A romantic and sweet blend that seduces with juicy raspberry and creamy vanilla.",
    price: 400.0,
  },
  {
    name: "Earthen Hair Nectar",
    img: img9,
    gender: "Unisex",
    season: "Winter",
    occasion: "Evening",
    notes: ["Vetiver", "Clove", "Earth"],
    intensity: "moderate",
    description:
      "Earthy and grounded, this winter scent is rooted in nature's raw richness.",
    price: 450.0,
  },
  {
    name: "Mystic Bloom Bottle",
    img: img10,
    gender: "Female",
    season: "Fall",
    occasion: "Mysterious",
    notes: ["Gardenia", "Frankincense", "Musk"],
    intensity: "strong",
    description:
      "An enigmatic floral fragrance with mystical layers of incense and musk.",
    price: 500.0,
  },
  {
    name: "Petal Crown",
    img: img11,
    gender: "Female",
    season: "Spring",
    occasion: "Royal Gathering",
    notes: ["Magnolia", "Iris", "Amber"],
    intensity: "moderate",
    description:
      "A regal composition of soft petals and glowing amber, fit for a queen.",
    price: 400.0,
  },
  {
    name: "Verdant Velvet",
    img: img12,
    gender: "Unisex",
    season: "Fall",
    occasion: "Outdoor",
    notes: ["Basil", "Moss", "Vetiver"],
    intensity: "moderate",
    description:
      "Inspired by mossy woods and green trails — perfect for autumn adventures.",
    price: 450.0,
  },
  {
    name: "Prismatic Petal",
    img: img13,
    gender: "Female",
    season: "Summer",
    occasion: "Festival",
    notes: ["Freesia", "Citrus", "Vanilla"],
    intensity: "light",
    description:
      "A fun, playful scent for vibrant summer festivals, bursting with bright petals and citrus.",
    price: 300.0,
  },
  {
    name: "The Herbalist's Cabinet",
    img: img14,
    gender: "Unisex",
    season: "Spring",
    occasion: "Nature Walk",
    notes: ["Sage", "Lavender", "Cedar"],
    intensity: "light",
    description:
      "A green and woody aroma reminiscent of spring walks through herbal gardens.",
    price: 350.0,
  },
];

export default perfumesData;
